import {
  secureDelete, secureGet, securePost, securePut,
} from 'config/apiConfig';

export const defaultMessage = 'Erreur système';
export const getUsers = async (sortParams = {}) => {
  const { page = 0, size = 10, sort } = sortParams;
  const url = `/users?page=${page}&size=${size}${sort ? `&sort=${sort}` : ''}`;
  const { data } = await secureGet(url);
  return data;
};
export const deleteUser = async (id) => {
  const { data } = await secureDelete(`/users/delete/${id}`);
  return data;
};
export const addUser = async (user) => {
  const { data } = await securePut('/users/add', user);
  return data;
};
export const resteUserPassword = async (body) => {
  const { data } = await securePost('/users/password/reset', body);
  return data;
};
export const ChangeMyPassword = async (body) => {
  const { data } = await securePost('/users/password/change', body);
  return data;
};
